import React, { useEffect } from 'react';
import { di } from 'react-magnetic-di';
import withAnalyticsContext from '@atlaskit/analytics-next/withAnalyticsContext';
import { AtlassianNavigation } from '@atlaskit/atlassian-navigation/atlassian-navigation';
import { ProductHome } from '@atlaskit/atlassian-navigation/product-home';
import { JiraServiceManagementIcon, JiraServiceManagementLogo } from '@atlaskit/logo';
import { AvatarMenuV2 } from '@atlassian/help-center-avatar-menu';
import AppSwitcherComponent from './app-switcher';
export interface HeaderProps {
	fetchUser: () => void;
}

const HomeIcon = () => <JiraServiceManagementIcon size="xsmall" appearance="brand" />;
const HomeLogo = () => <JiraServiceManagementLogo size="xsmall" appearance="brand" />;

const Home = () => (
	<ProductHome icon={HomeIcon} logo={HomeLogo} href={`${window.location.origin}/jira/your-work`} />
);

const AppSwitcher = () => <AppSwitcherComponent />;

const Header: React.FC<HeaderProps> = ({ fetchUser }: HeaderProps) => {
	di(AvatarMenuV2);

	useEffect(() => {
		fetchUser();
	}, [fetchUser]);

	return (
		<AtlassianNavigation
			label="site"
			renderProductHome={Home}
			renderProfile={AvatarMenuV2}
			renderAppSwitcher={AppSwitcher}
			primaryItems={[]}
		/>
	);
};

export default withAnalyticsContext({ component: 'Header' })(Header);
